var map = {
	"./logo.BBVA.png": 4858,
	"./logo.BNP.png": 6321,
	"./logo.BST.png": 9494,
	"./logo.Banco Provincia.png": 1809,
	"./logo.Banco ciudad.png": 622,
	"./logo.Banco de Comercio.png": 4334,
	"./logo.Banco patagonia.png": 2618,
	"./logo.Banco rioja.png": 8841,
	"./logo.Bancor.png": 4904,
	"./logo.Bibank finak.png": 1103,
	"./logo.Bica.png": 6826,
	"./logo.Bind.png": 7944,
	"./logo.Brubank.png": 3194,
	"./logo.CMF corporativo.png": 5343,
	"./logo.Citi.png": 9476,
	"./logo.Coinag.png": 8789,
	"./logo.Comafi.png": 1450,
	"./logo.Credicoop.png": 8215,
	"./logo.Dino.png": 785,
	"./logo.Efectivo si.png": 2478,
	"./logo.Entre rios.png": 8956,
	"./logo.Galicia.png": 2263,
	"./logo.GaliciaMas.png": 2766,
	"./logo.Hipotecario.png": 7154,
	"./logo.IB.png": 3360,
	"./logo.ICBC.png": 84,
	"./logo.Itau.png": 5780,
	"./logo.Jp Morgan.png": 8059,
	"./logo.Julio.png": 5020,
	"./logo.Macro.png": 2217,
	"./logo.Mariva.png": 5559,
	"./logo.Meridian.png": 8288,
	"./logo.Nacion.png": 5517,
	"./logo.Neuquen.png": 9406,
	"./logo.Nuevo Banco del Chaco.png": 3030,
	"./logo.Piano.png": 3866,
	"./logo.Reba financiera.png": 4801,
	"./logo.Saenz.png": 175,
	"./logo.San Juan.png": 7757,
	"./logo.Santa Cruz.png": 6542,
	"./logo.Santa fe.png": 2535,
	"./logo.Santander.png": 2697,
	"./logo.Santiago del estero.png": 2310,
	"./logo.Supervielle.png": 6997,
	"./logo.Tierra del fuego.png": 8419,
	"./logo.Transatlantica.png": 4994,
	"./logo.Voii.png": 5274,
	"./logo.china.png": 8848,
	"./logo.columbia.png": 773,
	"./logo.de Corrientes.png": 5960,
	"./logo.de comercio.png": 3311,
	"./logo.de la pampa.png": 2660,
	"./logo.del chubut.png": 3567,
	"./logo.del sol.png": 2972,
	"./logo.formosa.png": 7828,
	"./logo.hsbc.png": 8127,
	"./logo.mas ventas.png": 7051,
	"./logo.municipal.png": 5541,
	"./logo.roela.png": 2374,
	"./logo.sucredito.png": 9195,
	"./logo.valo.png": 2133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3389;